"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Snackbar_1 = __importDefault(require("@material-ui/core/Snackbar"));
const react_1 = __importStar(require("react"));
class SuccessSnackbar extends react_1.Component {
    constructor() {
        super(...arguments);
        this.state = { open: true };
        this.handleClose = () => {
            this.setState({ open: false });
        };
    }
    render() {
        const { open } = this.state;
        const { message, action } = this.props;
        return (react_1.default.createElement(Snackbar_1.default, { open: open, onClose: this.handleClose, message: message, action: action }));
    }
}
exports.default = SuccessSnackbar;
//# sourceMappingURL=SuccessSnackbar.js.map